import React from 'react'
import {
  FolderOpenOutlined,
  MessageOutlined,
  ReadOutlined,
  StockOutlined
} from '@ant-design/icons'
import { adminRoutes } from 'shared/constants/routes'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { useSellerAccess } from 'shared/hooks/useSellerAccess'
import { chatSelectors } from 'store/chat'
import { IMobileTab, MobileTabBar } from './MobileTabBar'

const CHATS_PATH = `${adminRoutes.PROFILE}/${adminRoutes.PROFILE_CHATS}`

export const SellerTabBar: React.FC = () => {
  const unreadChatCount = useAppSelector(chatSelectors.selectUnreadCount)
  const { canSeeSection } = useSellerAccess()

  const tabs: IMobileTab[] = [
    {
      key: adminRoutes.GOODS,
      label: 'Товары',
      icon: <FolderOpenOutlined />
    },
    {
      key: adminRoutes.ORDERS,
      label: 'Заказы',
      icon: <StockOutlined />
    },
    {
      key: CHATS_PATH,
      label: 'Сообщения',
      icon: <MessageOutlined />,
      badgeCount: unreadChatCount
    },
    {
      key: adminRoutes.PROFILE,
      label: 'Профиль',
      icon: <ReadOutlined />,
      // «Сообщения» — вложенный раздел профиля, иначе подсветились бы обе вкладки
      isActive: (pathname) =>
        pathname.startsWith(adminRoutes.PROFILE) && !pathname.startsWith(CHATS_PATH)
    }
  ]

  return <MobileTabBar tabs={tabs.filter((tab) => canSeeSection(tab.key))} />
}
